(() => {
  let saves = Promise.resolve();
  const ready = new WeakSet();
  const enqueue = task => {
    const next = saves.catch(() => {}).then(task);
    saves = next;
    return next;
  };
  class CartAgreement extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkbox.checked = false;
      this.error = this.querySelector('[role="alert"]');
      this.container = this.closest('main-cart') || this.parentElement;
      this.checkbox.addEventListener('change', () => this.changed());
      this.gate(false);
    }
    gate(enabled) {
      this.container.querySelectorAll('.additional-checkout-buttons').forEach(el => {
        el.inert = !enabled;
        el.classList.toggle('sbg-cart-express-locked', !enabled);
        el.setAttribute('aria-disabled', String(!enabled));
      });
    }
    message(kind) {
      this.error.textContent = this.error.dataset[kind + 'Message'];
      this.error.hidden = false;
    }
    save() {
      const checked = this.checkbox.checked;
      const note = document.querySelector('#Cart-Note, #CartDrawer-Note');
      const payload = {attributes: {'Terms accepted': checked ? 'Yes' : '', 'Terms accepted at': checked ? new Date().toISOString() : ''}};
      if (note) payload.note = note.value;
      return enqueue(async () => {
        const response = await fetch(this.dataset.updateUrl, {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify(payload)});
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      });
    }
    async changed() {
      this.error.hidden = true;
      this.gate(false);
      try {
        await this.save();
        if (this.isConnected) this.gate(this.checkbox.checked);
      } catch {
        this.checkbox.checked = false;
        this.message('save');
      }
    }
  }
  customElements.define('sbg-cart-agreement', CartAgreement);
  const agreementFor = button => {
    const id = button.getAttribute('form') || button.form?.id;
    return Array.from(document.querySelectorAll('sbg-cart-agreement')).find(el => el.dataset.formId === id);
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button) return;
    if (ready.has(button)) { ready.delete(button); return; }
    const agreement = agreementFor(button);
    if (!agreement) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!agreement.checkbox.checked) {
      agreement.message('required');
      agreement.checkbox.focus();
      agreement.checkbox.reportValidity();
      return;
    }
    if (agreement.pending) return;
    agreement.pending = true;
    button.setAttribute('aria-busy','true');
    try {
      await agreement.save();
      if (!agreement.isConnected || !agreement.checkbox.checked) return;
      ready.add(button);
      button.click();
    } catch {
      agreement.message('save');
    } finally {
      agreement.pending = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('submit', event => {
    const agreement = Array.from(document.querySelectorAll('sbg-cart-agreement')).find(el => el.dataset.formId === event.target.id);
    if (agreement && !agreement.checkbox.checked && event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      agreement.message('required');
      agreement.checkbox.focus();
    }
  }, true);
})();